import React, { useEffect, useState, useCallback } from 'react'
import { Header, TemplateContainer } from 'components'
import { LoadingContainer, PageTemplate } from './styles'

import { FormUpdateConcacts } from 'components/Presenters/UpdateContacts'
import { BiometyDataType, ContactsBiometry, UpdateContactsInicialValues } from 'typings/unico'
import { UNICO_CONSTANTS } from 'redesign/constants'
import { useUnicoService } from 'services/unico'
import { useHistory } from 'react-router-dom'
import { ROUTES_PATH } from 'constants/routesPath'
import { Loading } from '@dasa-health/components-react'
import { getOrigin } from 'utils'
import { mapFromResetContacts } from 'utils/contacts'
import { useTracking } from 'react-tracking'
import { useIsSafeURL } from 'redesign/hooks/useIsSafeURL'
import { SESSION_STORAGES_KEYS } from 'constants/sessionStorages'
import { useBiometry } from 'hooks/useBiometry'
import { useRecoverHook, useActivateHook } from 'hooks'
import { Contact } from 'typings'

const initialValues = {
    cellphone: '',
    email: '',
}

export const UpdateContactsUnico: React.FC = () => {
    const { createDraftFacialBiometryContacts } = useUnicoService()
    const [loading, setLoading] = useState(false)
    const [loadingCheckSessionStorageData, setLoadingCheckSessionStorageData] = useState(false)
    const history = useHistory()
    const { trackEvent } = useTracking()
    const { isSafeURL } = useIsSafeURL()
    const [validatedContacts, setValidatedContacts] = useState<Contact[]>([])
    const { createBiometry } = useBiometry(validatedContacts)

    const recover = useRecoverHook()
    const activeAccount = useActivateHook()
    const { username } = recover

    const biometyDataLS: BiometyDataType = JSON.parse(sessionStorage.getItem(UNICO_CONSTANTS.STORAGE)!)

    const user = username || biometyDataLS?.federalTaxId

    const userFormated = user?.replace(/[^a-z0-9]/gi, '')

    async function handleSubmit({ cellphone, email }: UpdateContactsInicialValues) {
        setLoading(true)

        const contacts = { email, cellphone } as ContactsBiometry

        try {
            const urlCallBack = await createBiometry()

            await new Promise(resolve => setTimeout(resolve, 300))

            const biometyData = JSON.parse(sessionStorage.getItem(UNICO_CONSTANTS.STORAGE) || '{}')
            const id = biometyData?.id

            await createDraftFacialBiometryContacts(contacts, id)

            trackEventSuccess(cellphone!, email!)
            sessionStorage.setItem(SESSION_STORAGES_KEYS.CONTACTS_BIOMETRY, JSON.stringify({ email, cellphone }))

            if (isSafeURL(urlCallBack!)) {
                window.open(urlCallBack, '_self')
            }
        } catch (error) {
            console.error('Erro no fluxo:', error)
            setLoading(false)
        }
    }

    function trackEventPage() {
        trackEvent({
            event: 'funnel_step',
            funnel: {
                name: getOrigin(biometyDataLS.origin),
                current_step: 'Adicionar contato',
                origin: getOrigin(biometyDataLS.origin),
            },
        })
    }

    function trackEventSuccess(cellphone: string, email: string) {
        const dadosPreenchidos = `${cellphone && 'telefone'}${email && ', email'}`

        trackEvent({
            event: 'funnel_step',
            funnel: {
                name: 'Reconhecimento Facial',
                current_step: `Contatos preenchidos | ${dadosPreenchidos}`,
                origin: getOrigin(biometyDataLS.origin!),
            },
        })
    }

    function redirectToLogin() {
        history.push(ROUTES_PATH.SIGN_IN)
    }

    function checkSessionStorageData() {
        setLoadingCheckSessionStorageData(true)
        if (biometyDataLS?.federalTaxId && biometyDataLS?.origin) {
            trackEventPage()
            setLoadingCheckSessionStorageData(false)
            return
        }

        redirectToLogin()
    }

    const getContacts = useCallback(async () => {
        try {
            setLoading(true)
            const contactsToReset = await activeAccount.getContactsToReset(userFormated!)
            recover.setContacts(userFormated!, mapFromResetContacts(contactsToReset))

            setValidatedContacts(mapFromResetContacts(contactsToReset))

            setLoading(false)
        } catch (err) {
            const codeError = err.graphQLErrors[0]?.extensions.code
            codeError === 'NOT_FOUND' && history.replace(ROUTES_PATH.SIGN_IN)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [userFormated])

    useEffect(() => {
        checkSessionStorageData()
        getContacts()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return loadingCheckSessionStorageData ? (
        <LoadingContainer>
            <Loading />
        </LoadingContainer>
    ) : (
        <TemplateContainer>
            <PageTemplate>
                <Header
                    subtitle="Preencha pelo menos um contato válido para facilitar o próximo acesso."
                    title="Qual contato deseja adicionar?"
                />
                <FormUpdateConcacts handleSubmit={handleSubmit} initialValues={initialValues} isSubmitting={loading} />
            </PageTemplate>
        </TemplateContainer>
    )
}
